/**
 * Provider for language
 * @module
 */
var BrowserSource = require('core/utils/browser');

module.exports = {
  provides: 'language',

  getter: [
    function() {
      return BrowserSource.getLanguage();
    },
  ],
};
